import { FunctionComponent } from 'react';

interface Step {
  key: string;
  label: string;
}

interface StepperProps {
  activeIndex?: number;
  steps?: Step[];
}

const Stepper: FunctionComponent<StepperProps> = ({
  activeIndex = 0,
  steps = [],
}) => {
  return (
    <div className="steps-wrapper text-center">
      <ul className="steps-listing list-unstyled">
        {steps.map((step, index) => (
          <li
            key={step.key}
            className={`${step.key}${index === activeIndex ? ' active' : ''}`}
          >
            <div className="step">
              <span>{index + 1}</span>
            </div>
            <h3 className="secondaryText">{step.label}</h3>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Stepper;
